import { useNavigate } from 'react-router-dom';
import { Empty } from 'antd';

import { PageHeader } from '../../../../components/PageHeader';
import { Loader } from '../../../../components/Loader';
import { CompanyInformation } from './components/CompanyInformation';
import { AnalysisPlots } from './components/AnalysisPlots';
import { ErrorList } from './components/ErrorList';
import { ExportAnalysisButton } from './components/ExportAnalysisButton';

import { useCompanyAnalyticsData } from './useCompanyAnalyticsData';

import { CompanyAnalyticsContainer } from './style';

export const CompanyAnalytics = () => {
  const navigate = useNavigate();
  const { companyAnalyticsData, loading } = useCompanyAnalyticsData();

  return (
    <>
      <PageHeader
        titleTranslationKey='companies.analyticsCompanyTitle'
        onBack={() => navigate('/front/companies')}
        extra={<ExportAnalysisButton companyData={companyAnalyticsData?.company} />}
      />
      <Loader loading={loading}>
        {companyAnalyticsData ? (
          <CompanyAnalyticsContainer>
            <CompanyInformation companyData={companyAnalyticsData.company} />
            <AnalysisPlots data={companyAnalyticsData.data} company={companyAnalyticsData.company} />
            <ErrorList errors={companyAnalyticsData.wcoxml} />
          </CompanyAnalyticsContainer>
        ) : (
          <Empty />
        )}
      </Loader>
    </>
  );
};
